import React from 'react';
import styles from './QuickAction.module.scss';
import { Icon } from '@mui/material';
import { Text } from '../../components/typography';
import classNames from 'classnames';

export default function QuickAction({
  title,
  icon,
  color,
  onClick,
  disabled = false,
  className,
  backgroundColor,
  textSize = 'sm',
  fullWidth = false,
}) {
  return (
    <div
      style={{ backgroundColor }}
      className={classNames(
        styles.container,
        fullWidth ? styles.fullWidthQuickAction : {},
        styles[color],
        disabled ? styles.disabled : null,
        className,
      )}
      onClick={onClick}
      data-cy={`quick-action-${title}`}
    >
      <Icon
        fontSize="inherit"
        baseClassName="material-icons-outlined"
        className={styles.icon}
      >
        {icon}
      </Icon>
      <Text
        size={textSize}
        color={'white'}
        noMargin
        weight="semiBold"
        textAlign="center"
        className={styles.maxWidth}
      >
        {title}
      </Text>
    </div>
  );
}
